// Session and URL management utilities
export const SESSION_KEYS = {
  LAST_VISITED_URL: 'lastVisitedUrl',
  REDIRECT_URL: 'redirectUrl',
  SESSION_EXPIRED: 'sessionExpired',
};

/**
 * Store the current URL as the last visited URL
 * This should be called on every route change
 */
export const storeCurrentUrl = () => {
  const currentPath = window.location.pathname + window.location.search;
  if (currentPath !== '/login' && currentPath !== '/') {
    sessionStorage.setItem(SESSION_KEYS.LAST_VISITED_URL, currentPath);
    console.log('Stored current URL:', currentPath); // Debug log
  }
};

/**
 * Get the last visited URL from storage
 */
export const getLastVisitedUrl = () => {
  const url = sessionStorage.getItem(SESSION_KEYS.LAST_VISITED_URL) || '/';
  console.log('Retrieved last visited URL:', url); // Debug log
  return url;
};

/**
 * Clear the stored URL
 */
export const clearStoredUrl = () => {
  sessionStorage.removeItem(SESSION_KEYS.LAST_VISITED_URL);
  sessionStorage.removeItem(SESSION_KEYS.REDIRECT_URL);
  sessionStorage.removeItem(SESSION_KEYS.SESSION_EXPIRED);
  console.log('Cleared stored URLs'); // Debug log
};

/**
 * Store redirect URL for session expiration
 */
export const storeRedirectUrl = () => {
  const currentPath = window.location.pathname + window.location.search;
  if (currentPath !== '/login') {
    sessionStorage.setItem(SESSION_KEYS.REDIRECT_URL, currentPath);
    sessionStorage.setItem(SESSION_KEYS.SESSION_EXPIRED, 'true');
    console.log('Stored redirect URL for session expiration:', currentPath); // Debug log
  }
};

/**
 * Get redirect URL for after login
 */
export const getRedirectUrl = () => {
  const redirectUrl = sessionStorage.getItem(SESSION_KEYS.REDIRECT_URL);
  const wasSessionExpired = sessionStorage.getItem(SESSION_KEYS.SESSION_EXPIRED);

  console.log('Checking redirect URL:', { redirectUrl, wasSessionExpired }); // Debug log

  if (redirectUrl && wasSessionExpired === 'true') {
    // Clear the stored redirect URL after retrieving it
    sessionStorage.removeItem(SESSION_KEYS.REDIRECT_URL);
    sessionStorage.removeItem(SESSION_KEYS.SESSION_EXPIRED);
    console.log('Returning redirect URL:', redirectUrl); // Debug log
    return redirectUrl;
  }

  return null;
};

/**
 * Check if user should be redirected after login
 */
export const shouldRedirectAfterLogin = () => {
  return sessionStorage.getItem(SESSION_KEYS.SESSION_EXPIRED) === 'true';
};

/**
 * Initialize URL tracking
 * This should be called when the app starts
 */
export const initializeUrlTracking = () => {
  // Store initial URL
  storeCurrentUrl();

  // Listen for route changes
  const originalPushState = window.history.pushState;
  const originalReplaceState = window.history.replaceState;

  window.history.pushState = function (...args) {
    originalPushState.apply(window.history, args);
    storeCurrentUrl();
  };

  window.history.replaceState = function (...args) {
    originalReplaceState.apply(window.history, args);
    storeCurrentUrl();
  };

  // Listen for popstate events (back/forward navigation)
  window.addEventListener('popstate', storeCurrentUrl);

  console.log('URL tracking initialized'); // Debug log
};
